import * as yup from 'yup';

export const rangesSchema = yup.object({
  includeNonAid: yup.boolean(),
  ranges: yup
    .array()
    .of(
      yup.object({
        from: yup
          .number()
          .nullable()
          .test('required', 'Required', (value) => value != null),
        to: yup
          .number()
          .nullable()
          .test('greater-than-from', 'Must be greater than From', function (to) {
            const { from } = this.parent;

            return from == null || to == null || to > from;
          }),
      }),
    )
    .test('intermediate-to-required', '', function (ranges) {
      if (!ranges) return true;

      for (let i = 0; i < ranges.length - 1; i++) {
        if (ranges[i].to == null) {
          return this.createError({
            path: `${this.path}[${i}].to`,
            message: 'Required',
          });
        }
      }

      return true;
    })
    .test('sequential-ranges', '', function (ranges) {
      if (!ranges) return true;

      for (let i = 1; i < ranges.length; i++) {
        const prev = ranges[i - 1];
        const curr = ranges[i];

        if (prev.to != null && curr.from != null && curr.from <= prev.to) {
          return this.createError({
            path: `${this.path}[${i}].from`,
            message: `Must be greater than ${prev.to}`,
          });
        }
      }

      return true;
    }),
});
